import "./event_norma"; import "./footer_norma"; import "./index.js"; import "./news_norma"
